module.exports = __webpack_public_path__ + "media/images/home/cours_collectifs-40984ba0ca9b1a52f3e40224165740fc.jpg";